import React from 'react'
import { createRoot } from 'react-dom/client'
import { createPortal } from 'react-dom'

import { StateProvider } from '@State'

import { Gradebook } from './components/Gradebook'
import { FilterForm } from './components/FilterForm'
import { reducer } from './reducer'

const App = ({ showAccountingButton }) => {
  const initialState = {
    page: 1,
    isPercentFormat: false,
    coursenum: window.location.pathname.split('/')[3],
    isCanvasCourse: false,
    filters: {},
    loading: true,
    limit: 50,
    showAccountingButton: showAccountingButton,
    sections: [],
    selectedSections: [],
    modal: {
      showModal: false,
      selectedActivity: {
        id: '',
        title: '',
      },
      modalBody: null,
    },
  }

  let gradebookNode = document.getElementById('app')
  let filterNode = document.getElementById('filter_form_container')
  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      {gradebookNode && createPortal(<Gradebook />, gradebookNode)}
      {filterNode && createPortal(<FilterForm />, filterNode)}
    </StateProvider>
  )
}

export const startGradebook = showAccountingButton => {
  const root = createRoot(
    document.createElement('div') // dummy root, could append to body
  )
  root.render(<App showAccountingButton={showAccountingButton} />)
}
